export const toTwoPrecision = (val: number) => {
  return parseFloat(val.toPrecision(12));
};
